<nb-card class="reason-dialog">
  <nb-card-header>{{ title | translate }}</nb-card-header>
  <nb-card-body>
    @if (subtitle) {
      <p class="subtitle">{{ subtitle }}</p>
    }
    <textarea nbInput fullWidth rows="3" [(ngModel)]="reason"
              [placeholder]="placeholder | translate"
              (keydown.control.enter)="submit()" (keydown.meta.enter)="submit()"></textarea>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost status="basic" (click)="cancel()">{{ cancelLabel | translate }}</button>
    <button nbButton [status]="status" [disabled]="required && !reason?.trim()" (click)="submit()">{{ confirmLabel | translate }}</button>
  </nb-card-footer>
</nb-card>
